export default __webpack_public_path__ + "static/yoga-5-89f13c08227930689520ae7dfaffc434.png";